export interface IStatus {
  currentId?: string; // will be used for attachment to hold downloading status
  currentAction?: string;
  status: IMessage;
  loading: boolean;
  downloaded?: boolean;
  confirmed?: boolean;
  result?: any;
}

export enum MessageType {
  ERROR = 1,
  INFO = 2
}

export interface IMessage {
  type: MessageType;
  message: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/types/status.ts